module.exports = "<div class=crop-area ng-style=$ctrl.cropAreaStyle() ng-mousemove=$ctrl.onMove($event) ng-mouseleave=$ctrl.onClickUp() ng-mouseup=$ctrl.onClickUp()> <img ng-src=\"{{ $ctrl.originalUrl }}\"> <div class=mask-box ng-style=$ctrl.getCropMask()></div> <div ng-style=$ctrl.cropBoxStyle() class=crop-box ng-mousedown=$ctrl.onBoxClickDown($event)></div> <span ng-mousedown=$ctrl.onResizeClickDown($event) ng-style=$ctrl.getResize() class=resize-dot></span> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/photo/crop/partial.html
// module id = 420
// module chunks = 0